var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567702137.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside1.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "center-content"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._m(0), _c("div", {
    staticClass: "left-content"
  }, [_c("div", {
    staticClass: "search"
  }, [_c("div", {
    staticClass: "input"
  }, [_c("i", {
    staticClass: "el-icon-search"
  }), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.videoName,
      expression: "videoName"
    }],
    attrs: {
      type: "text",
      placeholder: "请输入监控点名称"
    },
    domProps: {
      value: _vm.videoName
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.videoName = $event.target.value;
      }
    }
  })]), _c("div", {
    staticClass: "btn",
    on: {
      click: _vm.getVideoList
    }
  }, [_vm._v("搜索")])]), _c("div", {
    staticClass: "list"
  }, [_vm.labList.length ? _c("div", _vm._l(_vm.labList, function (item, index) {
    return _c("div", {
      key: item.labId,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "name",
      on: {
        click: function click($event) {
          return _vm.openClick(index);
        }
      }
    }, [_c("div", {
      staticClass: "icon"
    }, [_c("div", {
      staticClass: "line"
    }), !item.open ? _c("i", {
      staticClass: "el-icon-arrow-right"
    }) : _c("i", {
      staticClass: "el-icon-arrow-down"
    })]), _c("img", {
      attrs: {
        src: require("./image/largeVideo/icon-1.png"),
        alt: ""
      }
    }), _c("div", [_vm._v(_vm._s(item.labName))])]), item.open ? _c("div", {
      staticClass: "item-content"
    }, _vm._l(item.videoList, function (opt, idx) {
      return _c("div", {
        key: idx,
        staticClass: "option",
        class: {
          active: opt.active
        },
        on: {
          click: function click($event) {
            return _vm.videoClick(index, idx);
          }
        }
      }, [_c("div", {
        staticClass: "option-left"
      }, [_c("img", {
        attrs: {
          src: require("./image/largeVideo/icon-2.png"),
          alt: ""
        }
      }), _c("div", [_vm._v(_vm._s(opt.videoName))])]), _c("img", {
        staticClass: "option-right",
        attrs: {
          src: require("./image/largeVideo/icon-3.png"),
          alt: ""
        }
      })]);
    }), 0) : _vm._e()]);
  }), 0) : _vm._e(), !_vm.labList.length ? _c("div", {
    staticClass: "block"
  }, [_vm._v("无视频")]) : _vm._e()])])]), _c("div", {
    staticClass: "right"
  }, [_vm._l(_vm.videoList, function (opt, idx) {
    return _c("div", {
      key: opt.id,
      staticClass: "video"
    }, [!_vm.show ? _c("m3u8Video", {
      attrs: {
        id: opt.id
      }
    }) : _vm._e(), _c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(opt.videoName))]), _c("div", {
      staticClass: "full",
      on: {
        click: function click($event) {
          ;
          _vm.videoId = opt.id, _vm.show = true;
        }
      }
    }, [_vm._v("全屏")])], 1);
  }), !_vm.videoList.length ? _c("div", {
    staticClass: "block"
  }, [_vm._v("点击左侧视频，进行预览")]) : _vm._e()], 2)]), _c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside2.png"),
      alt: ""
    }
  })])]), _vm.show ? _c("div", {
    staticClass: "dialog"
  }, [_c("i", {
    staticClass: "el-icon-error close",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }), _c("m3u8Video", {
    attrs: {
      id: _vm.videoId
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeVideo/title.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("监控列表")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };